/* eslint-disable max-len */
import React from 'react';
import {
    DefaultButton,
    Dialog,
    DialogType,
    Stack,
    DialogFooter,
    PrimaryButton,
} from '@fluentui/react';
import { appStyles, Utilities } from '../../../../helpers';
import { useAppDispatch, useAppSelector } from '../../../../store';
import {
    selectDefaultFolderModalStep,
    selectDefaultFolderScope,
    selectFormDefaultFolderPath,
    selectFormDefaultFolderScope,
} from '../../../../store/selectors/defaultFolder';
import { selectTranslate } from '../../../../store/selectors/ui';
// eslint-disable-next-line max-len
import { DefaultFolderModalStep } from '../../../../store/reducers/defaultFolder/reducer';
// eslint-disable-next-line max-len
import { setDefaultFolderModalStep } from '../../../../store/actions/defaultFolder/actionCreators';
import { sendDefaultFolderFormThunk } from '../../../../store/actions/defaultFolder/thunks';
import { selectTeamsContext } from '../../../../store/selectors/conversation';
import { MappingType } from '@sendent/nextcloud-api';

export const ConfirmationModal = () => {
    const dispatch = useAppDispatch();
    const defaultFolderModalStep = useAppSelector(selectDefaultFolderModalStep);
    const defaultScope = useAppSelector(selectDefaultFolderScope);
    const selectedPath = useAppSelector(selectFormDefaultFolderPath);
    const selectedScope = useAppSelector(selectFormDefaultFolderScope);
    const teamsContext = useAppSelector(selectTeamsContext);
    const translate = useAppSelector(selectTranslate);

    const isConfirmOverwriteOpen =
        defaultFolderModalStep === DefaultFolderModalStep.Confirmation;

    const channelOrTeamName =
        selectedScope === MappingType.Channel
            ? teamsContext?.channel?.displayName
            : teamsContext?.team?.displayName;

    const folderName = selectedPath?.split('/').pop() ?? '';

    return (
        <Dialog
            styles={appStyles.DialogStyle}
            hidden={!isConfirmOverwriteOpen}
            onDismiss={() => dispatch(setDefaultFolderModalStep(null))}
            dialogContentProps={{
                type: DialogType.normal,
                title: Utilities.formatString(
                    selectedScope === defaultScope
                        ? translate('overwrite_default_folder')
                        : translate('confirm_set_default_folder'),
                    selectedScope ?? '',
                ),
            }}
        >
            <Stack tokens={{ childrenGap: 12 }}>
                <span>
                    {selectedScope === defaultScope
                        ? Utilities.formatString(
                              translate('default_folder_already_set'),
                              selectedScope ?? '',
                              folderName,
                          )
                        : Utilities.formatString(
                              translate('set_default_folder_details'),
                              folderName,
                              channelOrTeamName ?? '',
                              selectedScope ?? '',
                          )}
                </span>
            </Stack>
            <DialogFooter>
                <DefaultButton
                    styles={appStyles.primaryButtonReverse}
                    text={translate('button_cancel')}
                    onClick={() => dispatch(setDefaultFolderModalStep(null))}
                />
                <PrimaryButton
                    styles={appStyles.primaryButton}
                    text={translate('button_confirm')}
                    onClick={() => {
                        dispatch(sendDefaultFolderFormThunk());
                    }}
                />
            </DialogFooter>
        </Dialog>
    );
};
